export default function Mean_Median_Mode() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Mean_Median_Mode</h1>
      <p>Content for Mean_Median_Mode goes here.</p>
    </div>
  );
}